module.exports = {"230725100":"带岭镇","230725101":"朗乡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230725.json
// module id = 851
// module chunks = 0